import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-inactivity-alert',
  templateUrl: './inactivity-alert.component.html',
  styleUrls: ['./inactivity-alert.component.scss'],
  standalone: true,
  imports: [NgIf, DialogModule, Button, TranslateModule]
})
export class InactivityAlertComponent implements OnInit, OnDestroy {
  @Input() visible: boolean = false;
  @Input() countdown: number = 60; // Segundos restantes
  @Output() onContinue = new EventEmitter<void>();
  @Output() onTimeout = new EventEmitter<void>();

  private timer: any;
  public countdownDisplay: number = 60;

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    this.countdownDisplay = this.countdown;
    this.startCountdown();
  }

  ngOnDestroy() {
    this.stopCountdown();
  }

  startCountdown() {
    if (this.visible) {
      this.timer = setInterval(() => {
        this.countdownDisplay--;
        
        if (this.countdownDisplay <= 0) {
          this.stopCountdown();
          this.onTimeout.emit();
        }
      }, 1000);
    }
  }

  stopCountdown() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  continueSession() {
    this.stopCountdown();
    this.onContinue.emit();
  }

  // Método para reiniciar el countdown cuando se detecta actividad
  resetCountdown() {
    this.countdownDisplay = this.countdown;
    this.stopCountdown();
    if (this.visible) {
      this.startCountdown();
    }
  }

  // Watchers para cambios en los inputs
  ngOnChanges() {
    if (this.visible && !this.timer) {
      this.countdownDisplay = this.countdown;
      this.startCountdown();
    } else if (!this.visible) {
      this.stopCountdown();
    }
  }
}
